export const buttonModes = {
  filled: 'filled',
  outline: 'outline',
  flat: 'flat',
  'flat-icon': 'flat-icon',
  clear: 'clear'
}

export const labelModes = {
  line: 'line',
  hidden: 'hidden',
  outline: 'outline'
}
